import moment from 'moment';
import { Delta } from 'quill/core';
import React from 'react';
import ProductUpdateCard from './ProductUpdateCard';

const PUBLISHED_DATE = '2025-07-16';
const BANNER_URL =
  'https://slab.com/static/b24174c4470c490a7e855dcc185d198b/07839/banner.png';
const BLOG_URL =
  'https://slab.com/blog/new-in-slab-post-history-and-activities/';
const CONTENT = new Delta([
  {
    insert:
      'New in Slab: Understand Every Post’s History and Activity\nWe’ve rolled out a major update to how you see and review updates in Slab posts — making it easier than ever to follow what’s new, what’s been said, and what needs your attention.\n🕰️ Redesigned Post History',
  },
  {
    attributes: { header: 2, 'header-id': 'h5jfj' },
    insert: '\n',
  },
  {
    insert:
      'Post history just got a major glow-up. It’s not only more powerful — it’s also easier and more pleasant to use.\nNow, comments appear directly in context with the post content, so you can see exactly what changed ',
  },
  { attributes: { italic: true }, insert: 'and' },
  {
    insert:
      ' what was said about it. You’ll also notice visual cues for new threads, replies, and resolved discussions, making it effortless to track conversations over time.\n',
  },
  {
    insert: {
      image: [
        {
          source:
            'https://slab.com/static/6d6c5a046ec66362e1817f944a52bf21/42cbc/history.png',
        },
      ],
    },
  },
  {
    insert:
      "To top it off, links to specific headers and comments now work right from history, so jumping to the right section is quick and seamless. Whether you're catching up on changes or reviewing feedback, the new Post History helps you do it faster, clearer, and with more confidence.\n📌 New: Post Activity Timeline",
  },
  {
    attributes: { header: 2, 'header-id': 'hjmoi' },
    insert: '\n',
  },
  {
    attributes: { float: 'right' },
    insert: {
      image: [
        {
          source:
            'https://slab.com/static/4c264a108ac8227993e8dbb9658b071e/64756/activity.png',
        },
      ],
    },
  },
  {
    insert:
      'No more digging through posts to understand what’s changed or what needs your attention — now, it’s all right there.\nThe new ',
  },
  { attributes: { bold: true }, insert: 'Post Activity' },
  {
    insert:
      ' timeline gives you a clear, chronological view of everything that’s happened: edits, comments, publishing, verification, and more. You’ll even see the last time ',
  },
  { attributes: { italic: true }, insert: 'you' },
  {
    insert:
      ' viewed the post, so you can quickly spot what’s new since then.\nA dedicated ',
  },
  { attributes: { bold: true }, insert: 'Unresolved' },
  {
    insert:
      ' comments section ensures nothing slips through the cracks — no more scrolling or hunting for threads. And with colored indicators for recent edits and open comments, you’ll always know which posts need a closer look.\n🐭 Small but Mighty',
  },
  {
    attributes: { header: 2, 'header-id': 'hx7qn' },
    insert: '\n',
  },
  {
    attributes: { bold: true },
    insert: 'Topbar Menu Reorganization',
  },
  {
    insert:
      ' - We’ve cleaned up the topbar menus to reduce clutter and improve navigation — everything is easier to find and more consistent.',
  },
  { attributes: { list: 'bullet' }, insert: '\n' },
  {
    attributes: { bold: true },
    insert: 'Streamlined Topic Icons',
  },
  {
    insert:
      ' - The blue topic icon and privacy indicator have been merged, giving more space for post titles and topic names, plus improved sidebar menu organization.',
  },
  { attributes: { list: 'bullet' }, insert: '\n' },
  {
    attributes: { bold: true },
    insert: 'More Secure Images & Attachments',
  },
  {
    insert:
      ' - In the coming weeks, we’re adding token-based protection for links to uploaded images and attachments. This adds an extra layer of security without impacting day-to-day browsing in Slab.',
  },
  { attributes: { list: 'bullet' }, insert: '\n' },
  { insert: '\n\n' },
]);

export const shouldShowProductUpdate = moment(PUBLISHED_DATE)
  .add(7, 'day')
  .isAfter(moment());

const JulyProductUpdate = () => {
  if (!shouldShowProductUpdate) {
    return null;
  }

  return (
    <ProductUpdateCard
      banner={BANNER_URL}
      newTabTo={BLOG_URL}
      content={CONTENT}
      publishedDate={moment(PUBLISHED_DATE).format('MMMM D, YYYY')}
    />
  );
};

export default JulyProductUpdate;
